import { GiftCards, Users } from '@prisma/client';
import * as yup from 'yup';
import { cleanCents } from '../../utils/global/helper';
import { SORTABLE_KEYS } from '../../constants/gift-cards';

export interface GiftCardsOverviewResult {
  activations: number;
  redemptions: number;
  outstanding: number;
  expirationDays: number | null;
  hasGiftCards: boolean;
}

export interface GiftCard extends Omit<GiftCards, 'code'> {
  customer: {
    user: Pick<Users, 'firstName' | 'lastName' | 'email' | 'phoneNumber'>;
  } | null;
}

export type GiftCardsResult = GiftCard[];

export const giftCardSettingsSchema = yup.object({
  enabled: yup.boolean().required(),
  defaultGiftCardBalance: yup
    .number()
    .transform(val => cleanCents((val || 0) * 100))
    .min(0, 'Default gift card balance must be greater than or equal to 0')
    .integer('Default gift card balance must be a valid amount')
    .required(),
  expirationDays: yup
    .number()
    .min(1, 'Must be at least 1 day')
    .integer('Must be a whole number')
    .nullable(),
});

export type GiftCardSettingsPayload = yup.InferType<
  typeof giftCardSettingsSchema
>;

export interface GiftCardSettings {
  giftCardsEnabled: boolean;
  defaultGiftCardBalance: number;
}

export type SortableKeys = (typeof SORTABLE_KEYS)[number];

export type GiftCardsPage = {
  result: GiftCardsResult;
  meta: {
    cursor: string | undefined;
    hasMore: boolean;
    count: number;
  };
};

export interface GiftCardDetails {
  id: string;
  code: string;
  balance: number;
  email: string | null;
  phoneNumber: string | null;
  businessName: string | null;
  customerId: string | null;
}
